export interface PermissionProps {
  permission: string;
  policies: any;
}

const permissionCheckWithOwnPermission = (props: PermissionProps): boolean => {
  const { policies, permission } = props;
  if (policies?.[permission]) return true;
  return false;
};

export default permissionCheckWithOwnPermission;
